import { Component, Inject, Input, OnInit } from "@angular/core";
import { Property } from "@app/models/Property";
import { PropertyAddressLineItemDetail, PropertyApi } from "@app/services/apiServices/PropertyApi";
import { CouponData } from "@app/models/CouponData";
import { take } from "rxjs/operators";

type PropertyLineItemDetailsState = {
    loadingPropertyId: number
    loadedPropertyId: number
    lineItems: { display: string, amount: number }[]
}

@Component({
    selector: 'app-property-line-item-details',
    template: require('./property-line-item-details.component.html')
})
export class PropertyLineItemDetailsComponent implements OnInit {

    @Input() tid: string;
    @Input() property?: Property;
    @Input() isAnonymous?: boolean | false;
    @Input() propertyId: string | number | null;

    state: PropertyLineItemDetailsState;

    constructor(@Inject(PropertyApi) private propertyApi: PropertyApi ) {

        this.state = {
            lineItems: [],
            loadedPropertyId: null,
            loadingPropertyId: null,
        }

    }

    ngOnInit(): void {
        this.loadProperty(Number(this.propertyId))
    }

    private loadProperty(propertyId: number) {
        if (!propertyId) {
            this.state.loadingPropertyId = null;
            this.state.lineItems = [];
        } else if (this.state.loadedPropertyId === propertyId) {
            this.state.loadingPropertyId = null;
        } else {
            this.state.loadingPropertyId = propertyId;
            if (this.property) {
                let coupons: CouponData = {
                    pmcCouponId: this.property.hoa.pmc.couponId,
                    hoaCouponId: this.property.hoa.couponId,
                    propertyCouponId: this.property.couponId
                }
                return this.loadPropertyStep2(propertyId, coupons);
            } else {
                try {
                    this.propertyApi.propertiesIdGet(propertyId).pipe(take(1)).subscribe(resp => {
                        let coupons: CouponData = {
                            pmcCouponId: resp.hoa.pmc.couponId,
                            hoaCouponId: resp.hoa.couponId,
                            propertyCouponId: resp.couponId
                        }
                        return this.loadPropertyStep2(propertyId, coupons);
                    }, () => {
                        if (this.state.loadingPropertyId !== propertyId) {
                            // this request is out of date
                            return
                        }

                        this.state = {
                            loadingPropertyId: null,
                            loadedPropertyId: propertyId,
                            lineItems: [],
                            // no items
                        }
                    })
                } catch (err) {
                    if (this.state.loadingPropertyId !== propertyId) {
                        // this request is out of date
                        return
                    }

                    this.state = {
                        loadingPropertyId: null,
                        loadedPropertyId: propertyId,
                        lineItems: [],
                        // no items
                    }
                }
            }
        }
    }

    loadPropertyStep2(propertyId: number, coupons: CouponData) {
        if (this.state.loadingPropertyId !== propertyId) {
            // this request is out of date
            return
        }

        return this.propertyApi.propertyAddressGet(
            this.isAnonymous,
            coupons.pmcCouponId,
            coupons.hoaCouponId,
            coupons.propertyCouponId
        ).pipe(take(1)).subscribe((addrResp) => {
            let retLineItems;
            if(addrResp.lineItemDetails) {
                const lineItems: PropertyAddressLineItemDetail[] = (addrResp.lineItemDetails.sort((leftSide, rightSide): number => {
                    if (leftSide.sequenceId < rightSide.sequenceId) return -1;
                    if (leftSide.sequenceId > rightSide.sequenceId) return 1;
                    return 0;
                }) || []);
                retLineItems = lineItems.map(val => ({
                    display: val.alternateDescription || val.description || "Item",
                    amount: val.amountDue,
                }))
            }

            this.state = {
                loadingPropertyId: null,
                loadedPropertyId: propertyId,
                lineItems: retLineItems
            }
        }, () => {})
    }
}

